import socket from '../socketConfig'
import { userStore } from '@/store/user'

const CONTEXT = "professionals";

const userHandler = {
  setupEventListeners(): void {
    // Evento quando qualquer usuário da empresa é atualizado (para atualizar listas)
    socket.on(`${CONTEXT}:updatedUser`, async (data: any) => {
      const userState = userStore();
      const currentUserId = userState.user?.id || userState.user?.userId;

      // Normalizar IDs para comparação (converter ambos para número)
      const dataUserIdNum = Number(data.userId);
      const currentUserIdNum = Number(currentUserId);

      // Se for o próprio usuário logado, atualizar suas permissões
      if (!isNaN(dataUserIdNum) && !isNaN(currentUserIdNum) && dataUserIdNum === currentUserIdNum) {
        try {
          await userState.updateUserInfo();
        } catch (error) {
          console.error('❌ [userHandler] Erro ao atualizar permissões:', error);
        }
      }
    });

    // Evento específico quando as permissões do próprio usuário são atualizadas
    socket.on(`${CONTEXT}:permissionsUpdated`, async (data: any) => {
      const userState = userStore();
      const currentUserId = userState.user?.id || userState.user?.userId;

      // Normalizar IDs para comparação (converter ambos para número)
      const dataUserIdNum = Number(data.userId);
      const currentUserIdNum = Number(currentUserId);

      // Só atualizar se for o próprio usuário
      if (!isNaN(dataUserIdNum) && !isNaN(currentUserIdNum) && dataUserIdNum === currentUserIdNum) {
        try {
          await userState.updateUserInfo();
        } catch (error) {
          console.error('❌ [userHandler] Erro ao atualizar permissões:', error);
        }
      }
    });
  },

  removeEventListeners(): void {
    socket.off(`${CONTEXT}:updatedUser`);
    socket.off(`${CONTEXT}:permissionsUpdated`);
  }
}

export default userHandler
